import { Card } from 'primereact/card';
import { useParams } from 'react-router-dom';

function ProgramPage() {
    const { id } = useParams();

    return (
        <Card title="Program Dashboard" subTitle="Get all the info here" className="pageCard">
            Coming Soon {id}
        </Card>
    );
}

export default ProgramPage;
